import React, { Component } from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import './Feature.css';

class Feature extends Component {

    render() {

        const image = this.getImage();
        const text = this.getText();

        const content = <Row className='vertical-center'>
            {image}
            {text}
        </Row>;

        return (
            <section id={this.props.id} className='feature'>
                <Container>
                    {content}
                </Container>
            </section>
        );
    }

    getImage() {
        return <Col sm className={ `text-center ${this.props.layoutTextLeft ? 'order-lg-last ms-lg-5' : 'me-lg-5'}` } data-aos='fade-up'>
            {this.props.display}
        </Col>;
    }

    getText() {
        return <Col className='text-md-start mt-5 mt-lg-0' data-aos='fade-up'>
            <h2 className='display-4'>
                <span className={`gradient-${this.props.titleColor} gradient-text fw-bold`}>{this.props.title}</span>
                <br/>
                {this.props.lead}
            </h2>
            <br/>
            <p className='lead'>{this.props.content}</p>
            <a href={this.props.href}>Find out more</a>
        </Col>;
    }

}

export default Feature;